<template>
  <el-table class="omtable" border :data="tableData">
    <el-table-column label="加保时间" property="createTime" width="180">
      <template slot-scope="scope">
        {{$tools.formatDate(scope.row.createTime,'yyyy/MM/dd')}}
      </template>
    </el-table-column>
    <el-table-column label="加保保费（元）" property="addPremium"> </el-table-column>
    <el-table-column label="服务费比例" property="incomesRate">
      <template slot-scope="scope">
        {{scope.row.incomesRate||"-"}}
      </template>
    </el-table-column>
    <el-table-column label="服务费（元）" property="incomes">
      <template slot-scope="scope">
        {{scope.row.incomes||"-"}}
      </template>
    </el-table-column>
    <el-table-column label="结算日期" property="balanceDate">
      <template slot-scope="scope">
        {{scope.row.balanceDate?$tools.formatDate(scope.row.balanceDate,'yyyy/MM/dd'):"-"}}
      </template>
    </el-table-column>
    <el-table-column label="操作" width="120"> 
      <template slot-scope="scope">
        <el-button type="text" size='small' v-if="scope.row.addPolicyUrl" @click="jumpPage(scope.row.addPolicyUrl)">查看批单</el-button>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <emptyBox slot="empty"></emptyBox>
  </el-table>
</template>
<script>
export default {
  props: {
    policyNo: String,
  },
  data() {
    return {  
      tableData:[]
      
    };
  },
  watch:{
    policyNo:{
      handler(){
        this.getData();
      },
      immediate:true
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    getData(){
      this.$http({
        url: "/master/policy/queryAddPolicyRecord/"+this.policyNo,
        type: "get",
        params: {}
      }).then(res=>{
        this.tableData = res.data;
      })
    },
    jumpPage(url){
      location.href = url;
    }
  }
};
</script>